module.exports = __webpack_public_path__ + "static/media/crowd-gray.de10e675.png";